import { replace } from "react-router-redux";
import actionTypes from "../actionTypes";

export default ({ dispatch }) => next => action => {
  if (action.type !== actionTypes.PERMISSION_POST) {
    return next(action);
  }

  dispatch(replace("/permissions"));

  return next(action);
};



// WEBPACK FOOTER //
// ./src/redux/middleware/AfterFormSoftRedirects.js